import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import { FaApple, FaAndroid } from 'react-icons/fa';

const MobileAppPopup = () => {
    const [open, setOpen] = useState(false);
    const [platform, setPlatform] = useState(null); // 'ios' | 'android'

    useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
        const isAndroid = /Android/i.test(userAgent);
        
        const hasDismissed = localStorage.getItem('mobileAppPopupDismissed_v2');

        if (!hasDismissed) {
            if (isIOS) {
                setPlatform('ios');
                setOpen(true);
            } else if (isAndroid) {
                setPlatform('android');
                setOpen(true);
            }
        }
    }, []);

    const handleClose = () => {
        setOpen(false);
        localStorage.setItem('mobileAppPopupDismissed_v2', 'true');
    };

    const handleIOSDownload = () => {
        window.open('https://apps.apple.com/ca/app/track-copr-canada/id6748865450', '_blank');
        // We don't necessarily close it here for Android users who are just checking, but for iOS users downloading, yes.
        // Actually, let's keep it open or close it? Standard is to close or keep. Let's close.
        if (platform === 'ios') handleClose();
    };

    if (!platform) return null;

    return (
        <Dialog 
            open={open} 
            onClose={handleClose}
            PaperProps={{ sx: { borderRadius: 2, padding: 1 } }}
        >
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {platform === 'ios' ? <FaApple size={28} /> : <FaAndroid size={28} sx={{ color: '#3DDC84' }} />}
                <Typography variant="h6">
                    {platform === 'ios' ? 'Download the iOS App' : 'Mobile App Update'}
                </Typography>
            </DialogTitle>
            
            <DialogContent>
                {platform === 'ios' ? (
                    <>
                        <Typography variant="body1" gutterBottom>
                            Get the best experience with our new iOS app! Instant notifications and case tracking on the go.
                        </Typography>
                        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
                            <Button 
                                variant="contained" 
                                color="primary" 
                                onClick={handleIOSDownload}
                                startIcon={<FaApple />}
                                sx={{ textTransform: 'none', fontWeight: 'bold' }}
                            >
                                Download on App Store
                            </Button>
                        </Box>
                    </>
                ) : (
                    <>
                        <Typography variant="body1" paragraph>
                            <strong>Android App Coming Soon!</strong> We are currently waiting for Google approval.
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            However, the iOS app is already live! If you have an Apple device or want to share with friends:
                        </Typography>
                         <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
                             <Button
                                variant="outlined"
                                onClick={handleIOSDownload}
                                startIcon={<FaApple />}
                                sx={{ textTransform: 'none' }}
                             >
                                 View iOS App
                             </Button>
                         </Box>
                    </>
                )}
            </DialogContent>
            
            <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
                <Button onClick={handleClose} color="inherit" size="small" sx={{ textTransform: 'none', color: 'text.secondary' }}>
                    Continue in Browser
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default MobileAppPopup;
